import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const PC = () => {
  return (
			<div>
				<Header></Header>
				<br />
				<br />
				<br />
				<div class='row  mx-auto  p-5'>
					<div class='card  bg-gradient border-danger border-5' style={{ backgroundColor: '#003300' }}>
						<div class='card-body text-white'>
							<h1 class='card-title text-center'>POLITIQUE DE CONFIDENTIALITÉ</h1>
							<p class='card-text text-start'>
								<br />
								<h2>Responsable du traitement</h2>
								<br />
								Le responsable du traitement des données est : EPAVISTE MORO.
								<br />
								<br />
								<h2>Données collectées</h2>
								<br />
								Le site peut collecter les données suivantes :<li>Nom et prénom</li>
								<li>Numéro de téléphone</li>
								<li>Adresse email</li>
								<li>Adresse d’intervention</li>
								<li>Informations relatives au véhicule (immatriculation, état, localisation)</li>
								<br />
								<br />
								<h2>Modalités de collecte</h2>
								<br />
								Les données sont collectées lorsque vous :<li>Remplissez un formulaire de contact</li>
								<li>Effectuez une demande d’enlèvement de véhicule</li>
								<li>Contactez directement l’entreprise</li>
								<br />
								<br />
								<h2>Finalités du traitement</h2>
								<br />
								Les données sont utilisées pour :<li>Traiter les demandes d’enlèvement d’épave</li>
								<li>Contacter les utilisateurs</li>
								<li>Organiser les interventions</li>
								<li>Assurer le suivi client</li>
								<br />
								<br />
								<h2>Base légale</h2>
								<br />
								Le traitement repose sur :<li>Le consentement de l’utilisateur</li>
								<li>L’exécution d’une prestation de service</li>
								<br />
								<br />
								<h2>Durée de conservation</h2>
								<br />
								Les données sont conservées pendant une durée maximale de 3 ans à compter du dernier contact.
								<br />
								<br />
								<h2>Partage des données</h2>
								Les données ne sont jamais vendues. Elles peuvent être transmises uniquement à des partenaires ou prestataires nécessaires à l’exécution du
								service (dépanneurs, centres VHU agréés).
								<br />
								<br />
								<h2>Sécurité</h2>
								<br />
								Des mesures techniques et organisationnelles appropriées sont mises en place afin de garantir la sécurité des données personnelles.
								<br />
								<br />
								<h2>Droits des utilisateurs</h2>
								<br />
								Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :<li>Droit d’accès</li>
								<li>Droit de rectification</li>
								<li>Droit d’effacement</li>
								<li>Droit d’opposition</li>
								<li>Droit à la limitation du traitement</li> 
                Vous pouvez exercer vos droits à tout moment en envoyant une demande à :
                <br/>epavistemoro@gmail.com<br/>
								Vous avez également le droit d’introduire une réclamation auprès de la CNIL (www.cnil.fr).
                <br/>
                <br/>
                <h2>Cookies</h2>
                <br/>Le site peut utiliser des cookies pour améliorer l’expérience utilisateur.
                <br/>Un bandeau de consentement permet à l’utilisateur d’accepter ou refuser l’utilisation des cookies lors de
								sa première visite. 
                <br/>Les cookies peuvent être utilisés pour :
                <li>Mesure d’audience</li>
                <li>Fonctionnement du site</li> L’utilisateur peut à tout moment
								configurer ses préférences via son navigateur.
							</p>
						</div>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<Footer></Footer>
			</div>
		);
};

export default PC;
